import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import SideBar from "./Sidebar";
import { useEffect, useState } from "react";

export default function BaseLayout({ children }) {
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const scriptUrls = [
    "/assets/libs/simplebar/simplebar.min.js",
    "/assets/js/pages/plugins/lord-icon-2.1.0.js",
    "/assets/libs/prismjs/prism.js",
    "/assets/js/pages/dashboard-ecommerce.init.js",
    "/assets/js/pages/dashboard-crm.init.js",
    "/assets/js/pages/swiper.init.js",
    "/assets/js/pages/profile-setting.init.js",
    "/assets/js/app.js",
  ];

  // Set initial sidebar state based on screen size
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    return window.matchMedia("(min-width: 769px)").matches; 
  });

  useEffect(() => {
    setIsPageLoaded(true);

    if (isPageLoaded) {
      scriptUrls.forEach((scriptUrl) => {
        const script = document.createElement("script");
        script.src = scriptUrl;
        script.async = true;
        document.body.appendChild(script);
      });
    }

    // Add resize listener to update sidebar state on window resize
    const handleResize = () => {
      const isLargeScreen = window.matchMedia("(min-width: 769px)").matches;
      setIsSidebarOpen(isLargeScreen);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isPageLoaded]);

  const topFunction = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  return (
    <>
      <div id="layout-wrapper">
        <Header
          setIsSidebarOpen={setIsSidebarOpen}
          isSidebarOpen={isSidebarOpen}
        />
        <SideBar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <div className="vertical-overlay"></div>
        <div className={`main-content ${isSidebarOpen ? "" : "expand"}`}>
          <div className="page-content">
            <div className="container-fluid">{children}</div>
          </div>
          <Footer />
        </div>
      </div>

      <button
        onClick={topFunction}
        className="btn btn-danger btn-icon"
        id="back-to-top"
      >
        <i className="ri-arrow-up-line"></i>
      </button>
    </>
  );
}
